module.exports = __webpack_public_path__ + "media/images/icons/arrow-down-596ab9d138096df057f120e3d701d26d.svg";